@if (table.title) {
    <h2 class="fert-table-title">{{ table.title }}</h2>
}

<table class="table-style responsive-stacked" [class.no-index]="table.showIndex === false">
    @for (row of table.data; track row; let rowNumber = $index) {
        <tr
            [style.background]="table.style?.[rowNumber]"
            [style.color]="table.style?.[rowNumber] === '#222222' ? 'white' : 'black'"
            [attr.data-row]="rowNumber">
            @for (column of row; track column; let colNumber = $index) {
                @if (rowNumber === 0) {
                    @if (colNumber === 0 && table.showIndex !== false) {
                        <th class="idx-cell reactive-form-table-empty-heading"></th>
                    }
                    <th>{{ column }}</th>
                } @else {
                    @if (colNumber === 0 && table.showIndex !== false) {
                        <td class="idx-cell reactive-form-table-index-cell">{{ rowNumber }}</td>
                    }

                    <td [attr.data-label]="table.data?.[0]?.[colNumber] ?? ''" class="data-cell">
                        {{ column }}
                    </td>
                }
            }
        </tr>
    }
</table>
